const NotFound = () => (
  <div style={{ textAlign: 'center', padding: '5em 0' }}>
    <h3 style={{ fontSize: '3em' }}>
      Lo sentimos, pero la página que busca no existe.
    </h3>
  </div>
);

export default NotFound;
